module.exports = __webpack_public_path__ + "static/media/applied-discounts.884cd80f.svg";